import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsFiltering, selectPage, selectRowsPerPage } from 'store/Filters/selectors';
import { allServicesAreSelected, selectSelectAllServices, selectServicesCount, selectServicesSelected } from 'store/ServicesGeneral/selectors';
import { selectTotalServices, unSelectAllServices, unselectedRowFromSelectAll, unselectTotalServices } from 'store/ServicesGeneral/actions';
import { Wrapper, Text, Blue, Bold } from 'Screens/Contextualization/Manage/components/ManageTable/components/SelecAll/styled';

const SelectAll = () => {
  const dispatch = useDispatch();
  const allVisualServicesSelected = useSelector(allServicesAreSelected);
  const pageLimit = useSelector((state) => selectRowsPerPage('servicesGeneral', state));
  const page = useSelector((state) => selectPage('servicesGeneral', state));
  const selectAll = useSelector(selectSelectAllServices);
  const servicesSelected = useSelector(selectServicesSelected);
  const serviceCount = useSelector(selectServicesCount);
  const isFiltering = useSelector(state => selectIsFiltering('servicesGeneral', state));

  const handleSelectAll = () => {
    dispatch(selectTotalServices());
  };
  const handleClear = () => {
    dispatch(unselectTotalServices());
    dispatch(unSelectAllServices());
    dispatch(unselectedRowFromSelectAll(false));
  };

  const content = () => {
    if (selectAll) {
      return (
            <Text>
        All <Bold>{serviceCount}</Bold> Services  {isFiltering ? 'on this search' : ''} are selected. <Blue onClick={ handleClear }>Clear Selection</Blue>
            </Text>
      );
    } else if (isFiltering) {
      return (
<Text>
        All <Bold>{servicesSelected.length}</Bold> Services on this page are selected. <Blue onClick={ handleSelectAll }>Select all Services that match this search.</Blue>
</Text>
      );
    } else {
      return (
<Text>
        All <Bold>{servicesSelected.length}</Bold> Services on this page are selected. <Blue onClick={ handleSelectAll }>Select all {serviceCount} Services.</Blue>
</Text>
      );
    }
  };
  if (!allVisualServicesSelected) return null;
  if ((servicesSelected.length < pageLimit && page === 1 && !allVisualServicesSelected) || serviceCount <= pageLimit) return null;
  return <Wrapper> {content()} </Wrapper>;
};

export default SelectAll;
